/**
|--------------------------------------------------
| lib name : bot.config.v1.js
| description : this file contain widget integration configs
| author: a8.org
|--------------------------------------------------
*/
(function (g) {
  //extract info from  g.bot.theme
  function themeMiddleWare() {
    // maintain header theme here
    (this.header = {
      // use this prop to set title
      title: "A8 Bot",

      /*
       * use this style prop to style the title
       * provide the object with css styles
       * ex : titleStyle = {'color' : 'value', 'background-color' : 'value'}
       */
      titleStyle: {
        "font-size": "15pt",
        // "margin-left": "8px"
      },

      // use this prop to give subtitle
      subtitle: "We are here to help you?",

      /*
       * use this style prop to style the sub title
       * provide the object with css styles
       * ex : subTitleStyle = {'color' : 'value', 'background-color' : 'value', font : 'custom-font'}
       */
      subtitleStyle: { color: "#ffffff", "font-size": "9pt" },

      // use this wrapperStyle props to style the title wrapper
      wrapperStyle: {
      },

      //use this props to change the predefined header logos
      headerLogo: null,

      //use this props to style the haderlogowrapper style
      headerLogoWrapperStyle: {},

      //use this props to customize the headerLogo style
      headerLogoStyle: {},

      //use this props to style the min,max & close icons styles such as color,font-size etc...
      actionBarStyle: { color: "white" },

      headerLogoVisibility: 'show',

    }),
      (this.bot = {
        /*
         *  use this props to customize the user avatar icon
         *  availabel icons : enum['icon_1', 'icon_2]
         *  ex : botAvatar : "icon_1"
         *  if you do not want to load bot avatar just assign null ex : userAvatar : null
         * */
        botAvatar: null,

        //use this props to assign botName
        botName: "Allen",

        // provide the custom style for bot avatar
        avatarStyle: {
          "background": "#6CB33E",
          "color": "#ffffff"
        },

        // use this props to customise the avatarTextStyle
        avatarTextStyle: {},

        // responsible for handling textStyle inside the messageBox
        msgTextStyle: {},

        // responsible for handling message wrapper
        msgWrapperStyle: {},

        //use below prop to style the timeline style for bot side
        timeLineStyle: {}
      }),
      (this.user = {
        /*
         *  use this props to customize the bot avatar icon
         *  availabel icons : enum['icon_1', 'icon_2]
         *  ex : userAvatar : "icon_1"
         *  if you do not want to load user avatar just assign null ex : userAvatar : null
         * */
        userAvatar: null,

        //provide the custom style for user avatar
        avatarStyle: {
          "background": "#027600",
          "color": "#ffffff"
        },

        // use this props to customise the avatarTextStyle
        avatarTextStyle: {},

        // responsible for handling textStyle inside the messageBox
        msgTextStyle: {},

        // responsible for handling message wrapper
        msgWrapperStyle: {},

        //use below prop to style the timeline style for user side
        timeLineStyle: {}
      }),
      (this.global = {
        //use this props to provide the chat widget primary color
        primaryColor: "linear-gradient(90deg, rgba(108, 179, 62, 1) 0%, rgba(48, 145, 27, 1) 39.11%, rgba(2, 118, 0, 1) 100%)",
        primaryFontColor: '#027600',
        //use this props to provide the secondary color
        secondaryColor: null,
        scrollBarBGColor: 'rgba(213, 210, 210, 0)',
        scrollBarVHeight: "2",
        scrollBarColor: null,
        scrollBarHHeight: "2",
        // forecolor
        // use this props to set perfect front color for primaryColor/ bg color
        // it will appyly mostly on text
        foreColor: "white",

        //use this props to customize the dateformat
        // enum ["mm/dd", "dd/mm" ]
        chatMsgDateFormat: "dd/mm",

        //use this prop to style the chatbox wrapper style 
        chatBoxWrapper: {},
        primaryFont: "defaultPrimaryFont",
        secondaryFont: "defaultSecondaryFont",
        doodle: null,
        //use this prop to customize the notification widget
        notificationStyle: {}
      }),
      (this.typingBox = {
        // use this props to give typing area placeholder
        // type : string
        placeholder: null,

        // use this props to show or hide the toolBarVisibility
        // type : Boolean
        toolBarVisibility: true,

        // use this props to give typing-area wrapper style
        wrapperStyle: {}
      }),
      (this.launcher = {
        /*
         * This props contains some defualt beautiful launcher icons.
         * You can use it by seetting below types
         * enum ['icon_1' || 'icon_2']
         */
        launcherIcon: null,

        //use this props to customize the icon wrapper style
        //type should be object of valid css
        iconWrapperStyle: {},

        //use this props to customize the icon for web right & bottom
        web: {
          bottom: "10",
          right: "12"
        },

        //use this props to customize the icon for mobile right & bottom
        mobile: {
          bottom: "26",
          right: "16"
        }
      });
  }

  themeMiddleWare.prototype = {
    addHeaderConfigs(headerTheme) {
      try {
        // extract individual theme config from headerTheme
        let {
          title,
          titleStyle,
          subtitle,
          subtitleStyle,
          wrapperStyle,
          headerLogo,
          headerLogoWrapperStyle,
          headerLogoStyle,
          actionBarStyle,
          headerLogoVisibility,
        } = headerTheme;
        let where = "header";

        title &&
          this.processConfig({
            key: "title",
            value: title,
            type: "string",
            errorMsg: "Title must be string in header!",
            where
          });

        titleStyle &&
          this.processConfig({
            key: "titleStyle",
            value: titleStyle,
            type: "object",
            errorMsg:
              "titleStyle props from header theme config should be object of valid css styles",
            where
          });

        subtitle &&
          this.processConfig({
            key: "subtitle",
            value: subtitle,
            type: "string",
            errorMsg: "subtitle props must me string in header!",
            where
          });

        subtitleStyle &&
          this.processConfig({
            key: "subtitleStyle",
            value: subtitleStyle,
            type: "object",
            errorMsg:
              "subtitle props from header theme config should be object of valid css styles",
            where
          });

        wrapperStyle &&
          this.processConfig({
            key: "wrapperStyle",
            value: wrapperStyle,
            type: "object",
            errorMsg:
              "wrapperStyle props from header theme config should be object of valid css styles",
            where
          });

        headerLogo &&
          this.processConfig({
            key: "headerLogo",
            value: headerLogo,
            type: "string",
            errorMsg:
              "headerLogo props from header bot theme config must be string!",
            where
          });

        headerLogoWrapperStyle &&
          this.processConfig({
            key: "headerLogoWrapperStyle",
            value: headerLogoWrapperStyle,
            type: "object",
            errorMsg: "headerLogoWrapperStyle should be the valid object of css!",
            where
          });


        headerLogoStyle &&
          this.processConfig({
            key: "headerLogoStyle",
            value: headerLogoStyle,
            type: "object",
            errorMsg: "headerLogoStyle should be the valid object of css!",
            where
          });

        actionBarStyle &&
          this.processConfig({
            key: "actionBarStyle",
            value: actionBarStyle,
            type: "object",
            errorMsg:
              "actionBarStyle props from header theme config should be object of valid css styles",
            where
          });

        headerLogoVisibility &&
          this.processConfig({
            key: "headerLogoVisibility",
            value: headerLogoVisibility,
            type: "string",
            errorMsg: "headerLogoVisibility should be string!",
            where
          })

      } catch (error) {
        throw new Error(error);
      }
    },
    addBotConfigs(botConfigs) {
      try {
        //extract botConfigs
        let {
          botAvatar,
          avatarStyle,
          avatarTextStyle,
          msgTextStyle,
          msgWrapperStyle,
          timeLineStyle,
          botName,
        } = botConfigs;
        const where = "bot";
        botAvatar &&
          this.processConfig({
            key: "botAvatar",
            value: botAvatar,
            type: "string",
            errorMsg:
              "botAvatar type should be the string of valid URL",
            where
          });

        botName &&
          this.processConfig({
            key: "botName",
            value: botName,
            type: "string",
            errorMsg:
              "botName type should be the string of valid string",
            where
          });


        avatarStyle &&
          this.processConfig({
            key: "avatarStyle",
            value: avatarStyle,
            type: "object",
            errorMsg: "avatarStyle should be the object of valid css styles",
            where
          });

        timeLineStyle &&
          this.processConfig({
            key: "timeLineStyle",
            value: timeLineStyle,
            type: "object",
            errorMsg: "TimeLineStyle prop in global config should be the object of valid css styles!",
            where
          });

        avatarTextStyle &&
          this.processConfig({
            key: "avatarTextStyle",
            value: avatarTextStyle,
            type: "object",
            errorMsg:
              "avatarTextStyle should be the object of valid css styles",
            where
          });

        msgTextStyle &&
          this.processConfig({
            key: "msgTextStyle",
            value: msgTextStyle,
            type: "object",
            errorMsg: "msgTextStyle should be the object of valid css styles",
            where
          });

        msgWrapperStyle &&
          this.processConfig({
            key: "msgWrapperStyle",
            value: msgWrapperStyle,
            type: "object",
            errorMsg:
              "msgWrapperStyle should be the object of valid css styles",
            where
          });
      } catch (error) {
        throw new Error(error);
      }
    },
    addUserConfigs(userConfigs) {
      try {
        //extract userConfigs
        let {
          userAvatar,
          avatarStyle,
          avatarTextStyle,
          msgTextStyle,
          msgWrapperStyle,
          timeLineStyle
        } = userConfigs;
        const where = "user";

        userAvatar &&
          this.processConfig({
            key: "userAvatar",
            value: userAvatar,
            type: "string",
            errorMsg:
              "userAvatar type should be the string of valid enum icon type. ex : userAvatar : 'icon_1'",
            where
          });

        timeLineStyle &&
          this.processConfig({
            key: "timeLineStyle",
            value: timeLineStyle,
            type: "object",
            errorMsg: "TimeLineStyle prop in global config should be the object of valid css styles!",
            where
          });

        avatarStyle &&
          this.processConfig({
            key: "avatarStyle",
            value: avatarStyle,
            type: "object",
            errorMsg: "avatarStyle should be the object of valid css styles",
            where
          });

        avatarTextStyle &&
          this.processConfig({
            key: "avatarTextStyle",
            value: avatarTextStyle,
            type: "object",
            errorMsg:
              "avatarTextStyle should be the object of valid css styles",
            where
          });

        msgTextStyle &&
          this.processConfig({
            key: "msgTextStyle",
            value: msgTextStyle,
            type: "object",
            errorMsg: "msgTextStyle should be the object of valid css styles",
            where
          });

        msgWrapperStyle &&
          this.processConfig({
            key: "msgWrapperStyle",
            value: msgWrapperStyle,
            type: "object",
            errorMsg:
              "msgWrapperStyle should be the object of valid css styles",
            where
          });
      } catch (error) {
        throw new Error(error);
      }
    },
    addTypingBoxConfigs(typingBoxConfigs) {
      try {
        let { placeholder, toolBarVisibility, wrapperStyle } = typingBoxConfigs;
        const where = "typingBox";

        placeholder &&
          this.processConfig({
            key: "placeholder",
            value: placeholder,
            type: "string",
            errorMsg:
              "placeholder prop in typingBox config should be valid string!",
            where
          });

        toolBarVisibility &&
          this.processConfig({
            key: "toolBarVisibility",
            value: toolBarVisibility,
            type: "boolean",
            errorMsg:
              "toolBarVisibility prop in typingBox config should be boolean!",
            where
          });

        wrapperStyle &&
          this.processConfig({
            key: "wrapperStyle",
            value: wrapperStyle,
            type: "object",
            errorMsg:
              "wrapperStyle prop in typingBox config should be the object of valid css styles!",
            where
          });
      } catch (error) {
        throw new Error(error);
      }
    },
    addGlobalConfigs(globalConfigs) {
      try {
        //extract global configs
        let {
          primaryColor,
          primaryFontColor,
          secondaryColor,
          scrollBarBGColor,
          scrollBarColor,
          scrollBarVHeight,
          scrollBarHHeight,
          foreColor,
          fontFamily,
          chatMsgDateFormat,
          chatBoxWrapper,
          primaryFont,
          secondaryFont,
          doodle,
          notificationStyle
        } = globalConfigs;
        const where = "global";

        doodle &&
          this.processConfig({
            key: "doodle",
            value: doodle,
            type: "string",
            errorMsg: "doodle in global config should be string type!",
            where
          })

        primaryColor &&
          this.processConfig({
            key: "primaryColor",
            value: primaryColor,
            type: "string",
            errorMsg: "primaryColor in global config should be string type!",
            where
          });

        primaryFontColor &&
          this.processConfig({
            key: "primaryFontColor",
            value: primaryFontColor,
            type: "string",
            errorMsg: "primaryFontColor in global config should be string type!",
            where
          });

        secondaryColor &&
          this.processConfig({
            key: "secondaryColor",
            value: secondaryColor,
            type: "string",
            errorMsg: "secondaryColor in global config should be string!",
            where
          });

          scrollBarBGColor &&
          this.processConfig({
            key: "scrollBarBGColor",
            value: scrollBarBGColor,
            type: "string",
            errorMsg: "scrollBarBGColor in global config should be string!",
            where
          });

          scrollBarVHeight &&
          this.processConfig({
            key: "scrollBarVHeight",
            value: scrollBarVHeight,
            type: "string",
            errorMsg: "scrollBar Vertical Height in global config should be string!",
            where
          });

          scrollBarHHeight &&
          this.processConfig({
            key: "scrollBarHHeight",
            value: scrollBarHHeight,
            type: "string",
            errorMsg: "scrollBar Horizontal Height in global config should be string!",
            where
          });
          
          scrollBarColor &&
          this.processConfig({
            key: "scrollBarColor",
            value: scrollBarColor,
            type: "string",
            errorMsg: "scrollBarColor in global config should be string!",
            where
          });

        foreColor &&
          this.processConfig({
            key: "foreColor",
            value: foreColor,
            type: "string",
            errorMsg: "foreColor in global config should be string!",
            where
          });

        fontFamily &&
          this.processConfig({
            key: "fontFamily",
            value: fontFamily,
            type: "string",
            errorMsg: "fontFamily in global config should be string!",
            where
          });

        chatMsgDateFormat &&
          this.processConfig({
            key: "chatMsgDateFormat",
            value: chatMsgDateFormat,
            type: "string",
            errorMsg:
              "chatMsgDateFormat prop in global bot theme config must be string!",
            where
          });

        chatBoxWrapper &&
          this.processConfig({
            key: "chatBoxWrapper",
            value: chatBoxWrapper,
            type: "object",
            errorMsg: "chatBoxwrapper prop in global config should be the object of valid css styles!",
            where
          });

        notificationStyle &&
          this.processConfig({
            key: "notificationStyle",
            value: notificationStyle,
            type: "object",
            errorMsg: "notificationStyle prop in global config should be the object of valid css styles!",
            where
          });

        primaryFont && this.processConfig({
          key: "primaryFont",
          value: primaryFont,
          type: "string",
          errorMsg: "PrimaryFont prop in global config should be string type!",
          where
        })

        secondaryFont && this.processConfig({
          key: "secondaryFont",
          value: secondaryFont,
          type: "string",
          errorMsg: "Secondary Font prop in global config should be string type!",
          where
        })
      } catch (error) {
        throw new Error(error);
      }
    },
    addLauncherConfigs(launcherConfigs) {
      try {
        //extract launcherConfigs
        let { launcherIcon, iconWrapperStyle, web, mobile } = launcherConfigs;
        const where = "launcher";

        launcherIcon &&
          this.processConfig({
            key: "launcherIcon",
            value: launcherIcon,
            type: "string",
            errorMsg: "launcherIcon prop should be valid string!",
            where
          });

        web &&
          this.processConfig({
            key: "web",
            value: web,
            type: "object",
            errorMsg: "launcherIcon prop should be valid string!",
            where
          });

        mobile &&
          this.processConfig({
            key: "mobile",
            value: mobile,
            type: "object",
            errorMsg: "launcherIcon prop should be valid string!",
            where
          });

        iconWrapperStyle &&
          this.processConfig({
            key: "iconWrapperStyle",
            value: iconWrapperStyle,
            type: "object",
            errorMsg:
              "iconWrapperStyle prop in typingBox config should be the object of valid css styles!",
            where
          });
      } catch (error) {
        throw new Error(error);
      }
    },
    processConfig(data) {
      //extrace data
      let { key, value, type, errorMsg, where } = data;


      if ((type === "string") && typeof value === type) {
        // this[where] = { ...this[where], [key]: value };
        this[where][key] = value;
      } else if (type === "object" && typeof value === type) {
        // this[where][key] = { ...this[where][key], ...value };
        for (var item in value) {
          this[where][key][item] = value[item];
        }
      } else if (type === "url" && this.isUrl(value)) {
        // this[where] = { ...this[where], [key]: value };
        this[where][key] = value;
      } else if (type === "boolean" && typeof value === type) {
        // this[where] = { ...this[where], [key]: value };
        this[where][key] = value;
      } else {
        throw errorMsg;
        // console.error(errorMsg);
      }


      // if (type === "string" && typeof value === type) {
      //   this[where] = { ...this[where], [key]: value };
      // } else if (type === "object" && typeof value === type) {
      //   this[where][key] = { ...this[where][key], ...value };
      // } else if (type === "url" && this.isUrl(value)) {
      //   this[where] = { ...this[where], [key]: value };
      // } else if (type === "boolean" && typeof value === type) {
      //   this[where] = { ...this[where], [key]: value };
      // } else {
      //   throw errorMsg;
      //   // console.error(errorMsg);
      // }
    },
    isUrl(url) {
      var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
      if (!regex.test(url)) {
        return false;
      } else {
        return true;
      }
    },
    configTheme(themeObject) {
      try {

        //extract theme config from client
        let { global, header, bot, user, launcher, typingBox } = themeObject;

        //if header configs found override the default header theme configs
        header && this.addHeaderConfigs(header);

        //if bot configs found override the default bot theme configs
        bot && this.addBotConfigs(bot);

        //if user configs found override the default user configs
        user && this.addUserConfigs(user);

        //if typingBox configs found override the default typingBox configs
        typingBox && this.addTypingBoxConfigs(typingBox);

        //if launcher configs found override the default launcher configs
        launcher && this.addLauncherConfigs(launcher);

        //if global configs found override the default global theme configs
        global && this.addGlobalConfigs(global);
      } catch (error) {
        throw error;
      }
    }
  };

  g.$a8bot = g.$b = g.$a8 = new themeMiddleWare();
})(window);